import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'ard-general-delete-entity-dialog',
	templateUrl: './general-delete-entity-dialog.component.html'
})
export class GeneralDeleteEntityDialogComponent implements OnInit {
	viewLoading: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<GeneralDeleteEntityDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	onYesClick(): void {
		this.viewLoading = true;
		if (this.data.service.sil) {
			this.data.service.sil(this.data.id).subscribe((gelen) => {
				this.dialogRef.close(gelen);
			});
		}
		else { this.dialogRef.close(); }
	}
}
